import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  policies: [],
  fileStatus: null,
};
// our slice
const cancelOrderSlice = createSlice({
  name: "cancelOrder",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setPolicies: (state, { payload }) => {
      state.policies = payload;
    },
    setCancelOrderStatus: (state, { payload }) => {
      state.fileStatus = payload;
    },
  },
});

// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setPolicies,
  setCancelOrderStatus,
} = cancelOrderSlice.actions;

export const cancelOrderSelector = (state) => state.cancelOrder;

export const GetPoliciesByFileID = (fileID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FileID: fileID,
    };

    const results = await http
      .post("Order/GetPoliciesByFileID", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setPolicies(results?.data?.responseObject?.lstGetPolicy));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const CancelOrder = (reqs, UserID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = reqs;

    let req = { UserID: UserID, RequestObject: request };
    const results = await http.post("Order/CancelOrder", req).then((result) => {
      return result;
    });

    if (results.data.responseCode == 0) {
      dispatch(setCancelOrderStatus(results?.data?.responseObject?.fileStatus));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

// export the default reducer
export default cancelOrderSlice.reducer;
